import { ReactComponent as Sunny } from 'images/icons/sunny.svg';
import { ReactComponent as PartlySunny } from 'images/icons/partly_sunny.svg';
import { ReactComponent as PartlyCloudy } from 'images/icons/partly_cloudy.svg';
import { ReactComponent as CloudyDay } from 'images/icons/cloudy_day.svg';
import { ReactComponent as Windy } from 'images/icons/windy.svg';
import { ReactComponent as LightRain } from 'images/icons/light_rain.svg';
import { ReactComponent as Rainy } from 'images/icons/rainy.svg';
import { ReactComponent as Stormy } from 'images/icons/stormy.svg';
import { ReactComponent as Clear } from 'images/icons/clear.svg';
import { ReactComponent as CloudyNight } from 'images/icons/cloudy_night.svg';

export const WEATHER_API = 'https://api.weather.gov/';
export const FLAG_API = '/api/flag/';

export const SUNNY = 'sunny';
export const PARTLY_SUNNY = 'partlySunny';
export const PARTLY_CLOUDY = 'partlyCloudy';
export const CLOUDY_DAY = 'cloudyDay';
export const WINDY = 'windy';
export const LIGHT_RAIN = 'lightRain';
export const RAINY = 'rainy';
export const STORMY = 'stormy';
export const CLEAR = 'clear';
export const CLOUDY_NIGHT = 'cloudyNight';
export const WEATHER_ICONS = {
	[SUNNY]: Sunny,
	[PARTLY_SUNNY]: PartlySunny,
	[PARTLY_CLOUDY]: PartlyCloudy,
	[CLOUDY_DAY]: CloudyDay,
	[WINDY]: Windy,
	[LIGHT_RAIN]: LightRain,
	[RAINY]: Rainy,
	[STORMY]: Stormy,
	[CLEAR]: Clear,
	[CLOUDY_NIGHT]: CloudyNight,
}

export const HIGH_WIND = 20;